export const HOST_REGEXP = /^[a-z0-9._-]+(:\d{1,5})?$/;
